export default __webpack_public_path__ + "static/media/homePage_asset@2x.5c521c0f.png";